import React from "react";
import "./Header.css";

function Header() {
  return (
    <div>
      <h1 className="text-center m-0" id="app-title">
        TextCrypt Online
      </h1>
    </div>
  );
}

export default Header;
